import ArtTrack from '@material-ui/icons/ArtTrack';
import classNames from 'classnames';
import _, { isEmpty } from 'lodash';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import * as TELEMETRY from '../App/Constants/Telemetry';
import { TileStatus } from '../App/Constants/TileStatus';
import DashboardStore from '../App/Stores/DashboardStore';
import AuthorizationStore from '../App/Stores/AuthorizationStore';
import Tile from './Tile';
import Grid from '@material-ui/core/Grid';
import StreamContentDisplay from './StreamContentDisplay';
import StreamRelatedArticle from '../App/Models/StreamRelatedArticle';
import StreamArticle from '../App/Models/StreamArticle';

interface Props {
  authorizationStore: AuthorizationStore;
  dashboardStore: DashboardStore;
  title: string;
  loadData: Function;
  initialStatus?: TileStatus;
}

@observer
class StreamDetail extends Tile<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleNewsClick = () => {
    window.telemetry.logEvent(TELEMETRY.EVENTS.DASHBOARD_NEWS_STREAM);
  }

  renderHeader(article){
    console.log('type: ' + article.Type)
    switch(article.Type){
      case 'events':
        return(
          <div className="c-dashboard__article-news-info-header">               
            <StreamContentDisplay
                media={article.HeroMedia}
                extMedia={article.ExternalHeroMedia}
                type={article.HeroMediaType}
                >
            </StreamContentDisplay> 
            <span className="c-dashboard__article-news-info-header-title">
                {article.Title}
            </span>                
            <div className="c-dashboard__article-news-info-header-date">
              <span>
                Event Date: {moment(article.EventDate).format('D MMM YYYY')}
              </span>
            </div>
            <div className="c-dashboard__article-news-info-header-date">
              <span>
                Location: {article.Location}
              </span>
            </div>
          <div className="c-dashboard__article-news-info-header-break"><hr></hr></div>                
          </div>
        )
      
      case 'News':
      default:
        return(
          <div className="c-dashboard__article-news-info-header">               
            <StreamContentDisplay
                media={article.HeroMedia}
                extMedia={article.ExternalHeroMedia}
                type={article.HeroMediaType}
                >
            </StreamContentDisplay> 
            <span className="c-dashboard__article-news-info-header-title">
                {article.Title}
            </span>
            <div className={classNames("c-dashboard__article-news-info-header-author", isEmpty(article.Authour) ? '' : 'no-header' )}>
              <span>
                By {article.Author}
              </span>
            </div>              
            <div className="c-dashboard__article-news-info-header-date">
              <span>
                {moment(article.PublishDate).format('D MMM YYYY')}
              </span>
            </div>
          <div className="c-dashboard__article-news-info-header-break"><hr></hr></div>                
          </div>
        )
    }
  }

  renderRelatedImage(related){
    if(related.ThumbnailMedia){
      return (
        <div>
          <img className="c-dashboard__article-news-info-footer-related-image-not-logo" src={window.appSettings.aemStreamContentUrl + related.ThumbnailMedia._path} />
        </div>
      )
    }

    else {
      return (
      <img className="c-dashboard__article-news-info-footer-related-image-logo" src="/images/sff_logo.svg" />
      )
    }
  }
  handleClick = (article: StreamArticle) => {
    this.props.dashboardStore.selectRelatedArticle(article._path)
  }

  render() {
    const article = this.props.dashboardStore.streamSelectedArticle;    
    const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);
    console.log(article.RelatedNews);
      return (
        <>
          { 
          <Grid container={true} className='c-dashboard__article-container'>
            <div className="c-dashboard__article-news">
              {this.renderHeader(article)}
              <div className="c-dashboard__article-news-info">
                
                <div className="c-dashboard__article-news-info-content">
                  <div 
                    className="c-dashboard__article-news-info-content"
                    dangerouslySetInnerHTML={{__html: article.FirstContent.html}}
                    >
                  </div>
                <StreamContentDisplay
                  media={article.FirstMedia}
                  extMedia={article.ExternalFirstMedia}
                  type={article.FirstMediaType}
                  >
                </StreamContentDisplay>
                </div>
                
                <div className="c-dashboard__article-news-info-content">
                  <div
                    className="c-dashboard__article-news-info-content"
                     dangerouslySetInnerHTML={{__html: article.SecondContent.html}}
                     ></div>
                <StreamContentDisplay
                  media={article.SecondMedia}
                  extMedia={article.ExternalSecondMedia}
                  type={article.SecondMediaType}
                  >
                </StreamContentDisplay>
                </div>
                
                <div className="c-dashboard__article-news-info-content">
                  <div
                    className="c-dashboard__article-news-info-content"
                    dangerouslySetInnerHTML={{__html: article.ThirdContent.html}} ></div>
                </div>
                <StreamContentDisplay
                  media={article.ThirdMedia}
                  extMedia={article.ExternalThirdMedia}
                  type={article.ThirdMediaType}
                  >
                </StreamContentDisplay>                
                <div className="c-dashboard__article-news-info-content">
                  <div
                    className="c-dashboard__article-news-info-content"
                    dangerouslySetInnerHTML={{__html: article.FourthContent.html}} ></div>
                </div>
                <StreamContentDisplay
                  media={article.FourthMedia}
                  extMedia={article.ExternalFourthMedia}
                  type={article.FourthMediaType}
                  >
                </StreamContentDisplay>                
              </div>
              <div className='c-dashboard__article-news-info-footer'>                
                <div className="c-dashboard__article-news-info-footer-break"><hr></hr></div>
                <div className={classNames("c-dashboard__article-news-info-footer-related-section-heading", isEmpty(article.RelatedNews) ? 'no-footer' : '' )} >Related Articles</div>
                <div className={classNames("c-dashboard__article-news-info-footer-related", isEmpty(article.RelatedNews) ? 'no-footer' : '' )}>
                  {article.RelatedNews.map(rel=>{
                    return(
                      <div className="c-dashboard__article-news-info-footer-related-spacer">
                        <div className="c-dashboard__article-news-info-footer-related-block" onClick={() => this.handleClick(rel)}>
                          <div className="c-dashboard__article-news-info-footer-related-image">{this.renderRelatedImage(rel)}</div>
                          <div className="c-dashboard__article-news-info-footer-related-content">
                            <div className="c-dashboard__article-news-info-footer-related-title">{rel.Title}</div>
                            <div className="c-dashboard__article-news-info-footer-related-date">{
                              rel.EventDate ? moment(rel.EventDate).format('D MMM YYYY') : moment(rel.PublishDate).format('D MMM YYYY')
                            }</div>
                            <ResponsiveEllipsis
                              className="c-dashboard__article-news-info-footer-related-summary"
                              text={rel.Summary.plaintext ? rel.Summary.plaintext : ''}
                              maxLine="4"
                              ellipsis="..."
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })
                  }
                </div>         
              </div>
            </div>
            </Grid>
          }
        </>
      );

  }
}

export default StreamDetail;